<template>
  <div class="moneyDetail" style="background:#F5F5F8;max-height:100vh;">
    <van-nav-bar
      title="USD"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
     <div style="overflow: hidden;margin-top:-46px;">
    <img src="../../assets/images/new/qkl.png" style="float: left; width: 100%;height: 220px;" alt="">
  </div>
    <div class="content" style="padding:0px;margin-top:0px;">
     
      <van-list
      style="border-radius:0px;overflow: hidden;"
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="onLoad"
      >
        <div class="detail_card">
          <div style="display:flex;align-items:center;height: 50px;padding:0 15px;color:#fff;font-size:14px;background-color:#1D2230;">
        <span style="width: 80px;">USD</span>
        <span style="flex:1;text-align:center;">最新价</span>
        <div style="width: 120px;text-align:right;padding-right:30px;    box-sizing: border-box;">操作</div>
    </div>
         <div v-for="(item,index) in list" :key="index" @click="qubi(item.link)"  :style="{background:index%2==0?'#26324A':'#1D2230'}" style=" display:flex;align-items:center;height: 50px;padding:0 15px;color:#fff;font-size:13px;">
        <span style="width: 80px;">{{item.title}}</span>
        <div style="flex:1;text-align:center;">
          <p style="font-size:15px;">{{item.price}}</p>
          <!-- <p style="font-size:11px;">≈USD  1292.21</p> -->
        </div>
        <div style="text-align:right;width: 120px;">
          <div style="float:right; width: 80px;height: 30px;line-height:30px; border-radius:10px;background:#FF4600;color:#fff;font-size:14px;font-weight:bold;text-align:center;">前往购买</div>
        </div>
    </div>
        </div>
      </van-list>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
// import { UserMoney } from "@/components/model";
export default {
  name: "",
  data() {
    return {
    
      list: [],
      page: 0,
      loading: false,
      finished: false,
      refreshing: false,
      yishou: 0,
      daishou: 0
    };
  },
  mounted() {
    this.$toast.loading({
      message: "数据加载中...",
      forbidClick: true,
      duration: 1500
    });
  },

  methods: {
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;

      request
        .post("/pay/us/list", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
        if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.length; i++) {
         
            this.list.push(res.data.data[i]);
          }
          this.loading = false;

          if (res.data.data.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
          this.finished = true;
          this.loading = false;
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    }, qubi(e){
      console.log(e)
    window.location.href = e
  }
  },
 
  onClickLeft() {
    this.$router.go(-1);
  },

 
};
</script>

<style scoped lang="less">
/deep/ .van-hairline--bottom::after{
  border-bottom-width: 0px;
}
.moneyDetail /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.moneyDetail /deep/ .van-nav-bar__title {
  color: #fff;
}
.moneyDetail /deep/ .van-icon {
  color: #fff;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}

.moneyDetail /deep/ .van-nav-bar__title {
  color: #fff;
}
.moneyDetail /deep/ .van-icon {
  color: #fff;
}

.moneyDetail {
  // height: 100vh;
  // background-color: #f6f6f6;

  background-position: 0px -17px;
  background-size: 100%;
  .content {
     margin-top: -46px;
    padding: 15px 0;
   
    .interest_card {
      padding: 0px 15px;
      height: 90px;
      // border-bottom: 10px solid #eff2fb;
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: #fff;
      div {
        font-size: 13px;

        // display: flex;
    text-align: center;
        // align-items: center;
        span {
          margin-left: 10px;
          font-size: 21px;
          font-weight: bold;
          color: red;
        }
      }
    }
    .detail_card {
      .card_item {
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        padding: 18px 15px 18px 15px;
        background-color: #fff;

        .c1 {
          flex: 1;
          text-align: center;
          img {
            float: left;
            width: 20px;
            margin-right: 10px;
          }
        }
        .c2 {
          flex: 9;
          display: flex;
          flex-direction: column;
          .detail_text {
            font-size: 13px;
            // font-weight: 600;
            line-height: 20px;
            color: #333333;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
          }
          .c_time {
            font-size: 13px;
            line-height: 18px;
            color: #999999;
          }
        }
        .c3 {
          .c_money {
            color: #f62015;
            display: block;
            text-align: right;
          }
  margin-left: 10px;
          font-size: 17px;
          font-weight: bold;
        }
      }
      .card_item:last-child {
        border-bottom: 0px solid #eee;
      }
    }
  }
}
</style>

